import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { RetrieveService } from '../api/services/retrieve.service';
import { AudioMatchRun } from '../api/models/audio-match-run';
import { SearchParams } from './audiomatchruns-list.component';

/**
 * Data source for the  AudiomatchrunsList view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class AudiomatchrunsListDataSource implements DataSource<AudioMatchRun> {

  private audiomatchRunsSubject = new BehaviorSubject<AudioMatchRun[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private audiomatchRunsCount = new BehaviorSubject(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.audiomatchRunsCount.asObservable();

  constructor(private retrieveService: RetrieveService) {
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<AudioMatchRun[]> {
    return this.audiomatchRunsSubject.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.audiomatchRunsSubject.complete();
    this.loadingSubject.complete();
  }

  loadAudiomatchRuns(params: SearchParams) {

    this.loadingSubject.next(true);

    /* Retrieve audiomatch runs */
    this.retrieveService.getAudiomatchRunsList(params).pipe(
      catchError(() => {
        // console.error('getContentsList ERROR');
        return of([]);
      }),
      finalize(() => {
        // console.log('getContentsList OK');
        this.loadingSubject.next(false);
      })
    ).subscribe(contents => {
      // console.log(contents);
      this.audiomatchRunsSubject.next(contents);
    });

    /* Count audiomatch runs */
    this.retrieveService.countAudiomatchRuns(params).pipe(
      catchError(() => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    ).subscribe(count => {
      this.audiomatchRunsCount.next(count as number);
    });
  }
}

